/* eslint-disable class-methods-use-this */
import VenueBasedAccessPinsRepository from "@app-contexts/dashboard/features/access-pin/data/repositories/VenueBasedAccessPinsRepository";

import {
  AuthorizationType,
  type AuthorizationStrategy,
  type AuthorizationResult,
} from "../types";

export class AccessPinStrategy implements AuthorizationStrategy {
  type = AuthorizationType.ACCESS_PIN;

  static buildAuthorizationKeys(venueId: string): string[] {
    return [`${AuthorizationType.ACCESS_PIN}:${venueId}`];
  }

  async check(
    venueId: string,
    isAuthorizedFn: (type: AuthorizationType, resourceId: string) => boolean
  ): Promise<AuthorizationResult> {
    // First check if we already have authorization in memory/storage
    if (isAuthorizedFn(AuthorizationType.ACCESS_PIN, venueId)) {
      // Already authorized, return empty result (no new authorizations to add)
      return { authorized: true, authorizations: [] };
    }

    // Not authorized, return empty result
    return { authorized: false, authorizations: [] };
  }

  async authorize(venueId: string, pin: unknown): Promise<AuthorizationResult> {
    const repo = new VenueBasedAccessPinsRepository();
    await repo.setInjects({ venueId }).authorize({
      pin: pin as string,
    });

    return {
      authorized: true,
      authorizations: AccessPinStrategy.buildAuthorizationKeys(venueId),
    };
  }

  async revoke(venueId: string): Promise<string[]> {
    const repo = new VenueBasedAccessPinsRepository();
    await repo.setInjects({ venueId }).revoke();

    return AccessPinStrategy.buildAuthorizationKeys(venueId);
  }
}
